import { useMemo, useState, type ReactNode } from 'react'
import { ExternalMediaContext } from './externalMediaContext'

const STORAGE_KEY = 'kasia-external-media-consent'

function getInitialConsent() {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(STORAGE_KEY) === 'allowed'
}

export function ExternalMediaProvider({ children }: { children: ReactNode }) {
  const [allowed, setAllowed] = useState(getInitialConsent)
  const value = useMemo(
    () => ({
      allowed,
      allow: () => {
        window.localStorage.setItem(STORAGE_KEY, 'allowed')
        setAllowed(true)
      },
      revoke: () => {
        window.localStorage.removeItem(STORAGE_KEY)
        setAllowed(false)
      },
    }),
    [allowed],
  )

  return <ExternalMediaContext.Provider value={value}>{children}</ExternalMediaContext.Provider>
}
